import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import InviteUser from './InviteUser';
import ServicerTable from './ServicerUserTable';
import { ListContainer } from 'components';
import { texts } from 'utils/languages/fr';
import { inviteFormType } from 'utils/constants';

const ServicerUsers = () => {
    const { path } = useRouteMatch();

    return (
        <ListContainer>
            <Switch>
                <Route
                    path={`${path}/invite-servicer`}
                    render={() => (
                        <InviteUser
                            title={texts.CREATE_SERVICER_USER}
                            type={inviteFormType.SERVICER}
                        />
                    )}
                />
                <Route path={path} component={ServicerTable} />
            </Switch>
        </ListContainer>
    );
};

export default ServicerUsers;
